export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            有任何问题、建议或合作意向，欢迎随时与我们取得联系
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-3">
              <i className="ri-mail-line text-xl"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-950 mb-1">投搞合作</h3>
            <p className="text-xs md:text-sm text-foreground-600">contact@hanhanmanga.com</p>
          </div>

          <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-3">
              <i className="ri-question-answer-line text-xl"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-950 mb-1">意见反馈</h3>
            <p className="text-xs md:text-sm text-foreground-600">feedback@hanhanmanga.com</p>
          </div>

          <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-3">
              <i className="ri-shake-hands-line text-xl"></i>
            </div>
            <h3 className="font-heading text-base text-foreground-950 mb-1">商务合作</h3>
            <p className="text-xs md:text-sm text-foreground-600">biz@hanhanmanga.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}